import { create } from 'zustand';

type LiveChatPayload = Record<string, any> | undefined;

type LiveChatState<T = unknown> = {
  isOpen: boolean;
  isMinimized: boolean;
  email: string | undefined;
  username: string | undefined;
  payload: LiveChatPayload;
  open: (options?: { email?: string; username?: string; payload?: LiveChatPayload }) => void;
  minimize: () => void;
  restore: () => void;
  reset: () => void;
};

export function createLiveChatStore<T = unknown>() {
  return create<LiveChatState<T>>(set => ({
    isOpen: false,
    isMinimized: false,
    email: undefined,
    username: undefined,
    payload: undefined,
    open: ({ email, username, payload } = {}) =>
      set(state => ({
        isOpen: true,
        isMinimized: false,
        email: email ?? state.email,
        username: username ?? state.username,
        payload,
      })),
    minimize: () => set({ isMinimized: true }),
    restore: () => set({ isMinimized: false }),
    reset: () => set({ isOpen: false, isMinimized: false, email: undefined, username: undefined, payload: undefined }),
  }));
}

export const useLiveChat = createLiveChatStore<Record<string, string>>();
